import { Type } from '@sinclair/typebox';
import { cartSchema } from "../cart/index.mjs";
import { baseCommandSchema } from "./shared.mjs";
export const recoverCartCommandSchema = Type.Intersect([
    baseCommandSchema,
    Type.Object({
        command: Type.Literal('recoverCart'),
        cart: Type.Omit(cartSchema, ['ipAddress']),
    }),
]);
//# sourceMappingURL=cart.js.map